import {
  SiDocker,
  SiExpress,
  SiGit,
  SiLaravel,
  SiMongodb,
  SiMysql,
  SiNextdotjs,
  SiNodedotjs,
  SiPhp,
  SiPostgresql,
  SiReact,
  SiWordpress,
} from 'react-icons/si';

// Shown in the strip under the hero, in this order.
export const technologies = [
  { name: 'React', icon: SiReact, color: '#149eca' },
  { name: 'Next.js', icon: SiNextdotjs, color: '#0b1220' },
  { name: 'Node.js', icon: SiNodedotjs, color: '#5fa04e' },
  { name: 'Express', icon: SiExpress, color: '#0b1220' },
  { name: 'Laravel', icon: SiLaravel, color: '#ff2d20' },
  { name: 'PHP', icon: SiPhp, color: '#777bb4' },
  { name: 'MySQL', icon: SiMysql, color: '#00758f' },
  { name: 'PostgreSQL', icon: SiPostgresql, color: '#336791' },
  { name: 'MongoDB', icon: SiMongodb, color: '#47a248' },
  { name: 'WordPress', icon: SiWordpress, color: '#21759b' },
  { name: 'Docker', icon: SiDocker, color: '#1d63ed' },
  { name: 'Git', icon: SiGit, color: '#f05032' },
];
